// 📁 frontend/src/pages/HomeLandingPage.jsx
import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

export default function HomeLandingPage() {
  const navigate = useNavigate();

  const zones = [
    { name: 'حوارة', color: '#E63946', position: { top: '22%', left: '50%' } },
    { name: 'بيتا', color: '#457B9D', position: { top: '70%', left: '52%' } },
    { name: 'عورتا', color: '#1D3557', position: { top: '55%', left: '30%' } },
    { name: 'أودلا', color: '#A8DADC', position: { top: '70%', left: '30%' } },
    { name: 'أوصرين', color: '#2A9D8F', position: { top: '40%', left: '25%' } },
  ];

  const lines = [
    { from: zones[0], to: zones[4] },
    { from: zones[4], to: zones[2] },
    { from: zones[2], to: zones[3] },
    { from: zones[3], to: zones[1] },
    { from: zones[1], to: zones[0] },
  ];

  const getLineStyle = (from, to) => {
    const x1 = parseInt(from.position.left);
    const y1 = parseInt(from.position.top);
    const x2 = parseInt(to.position.left);
    const y2 = parseInt(to.position.top);

    const length = Math.hypot(x2 - x1, y2 - y1);
    const angle = Math.atan2(y2 - y1, x2 - x1) * (180 / Math.PI);

    return {
      position: 'absolute',
      top: `calc(${y1}% + 10px)`,
      left: `calc(${x1}% + 10px)`,
      width: `${length * 2.2}px`,
      height: '3px',
      backgroundColor: 'rgba(0,0,0,0.3)',
      borderRadius: '2px',
      transform: `rotate(${angle}deg)`,
      transformOrigin: '0 0',
    };
  };

  // الانتقال التلقائي بعد 4 ثواني
  useEffect(() => {
    const timer = setTimeout(() => {
      navigate('/categories');
    }, 2000);

    return () => clearTimeout(timer); // تنظيف التايمر
  }, [navigate]);

  // حدث عند الضغط على الزر
  const handleOrderClick = () => {
    navigate('/categories');
  };

  return (
    <div
      style={{
        direction: 'rtl',
        fontFamily: "'Cairo', sans-serif",
        textAlign: 'center',
        padding: '30px 20px',
        backgroundColor: '#fdfcfb',
        minHeight: '100vh',
      }}
    >
      <h1 style={{ fontSize: '34px', fontWeight: '800', marginBottom: '10px', color: '#1b1b1b' }}>
        🍽️ مطعم الأصالة
      </h1>
      <p style={{ color: '#444', marginBottom: '26px', fontSize: '18px', fontWeight: '500' }}>
        توصيل سريع إلى: بيتا، حوارة، عورتا، أودلا، أوصرين
      </p>

      <p style={{ color: '#888', fontSize: '14px', marginBottom: '7px' }}>
        👇 جاري نقلك لقائمة الطعام...
      </p>

      <div
        style={{
          width: '100%',
          maxWidth: '520px',
          height: '430px',
          margin: '0 auto 26px',
          background: 'linear-gradient(180deg, #ffffff 0%, #f7f7f7 100%)',
          borderRadius: '30px',
          position: 'relative',
          border: '2px solid #e9ecef',
          boxShadow: '0 8px 16px rgba(0,0,0,0.08)',
          overflow: 'hidden',
        }}
      >
        <p style={{ color: '#222', fontWeight: '700', fontSize: '16px', paddingTop: '12px' }}>
          📌 مناطق التوصيل
        </p>

        {lines.map((line, idx) => (
          <div key={idx} style={getLineStyle(line.from, line.to)} />
        ))}

        {zones.map((zone, index) => (
          <div
            key={index}
            style={{
              position: 'absolute',
              top: zone.position.top,
              left: zone.position.left,
              transform: 'translate(-50%, -50%)',
              padding: '10px 16px',
              backgroundColor: zone.color,
              borderRadius: '25px',
              color: '#fff',
              fontSize: '15px',
              fontWeight: '700',
              boxShadow: '0 6px 12px rgba(0,0,0,0.25)',
              cursor: 'default',
              animation: 'pulse 2.2s infinite',
            }}
          >
            {zone.name}
          </div>
        ))}

        <style>
          {`
            @keyframes pulse {
              0% { transform: scale(1) translate(-50%, -50%); }
              50% { transform: scale(1.12) translate(-50%, -50%); }
              100% { transform: scale(1) translate(-50%, -50%); }
            }
          `}
        </style>
      </div>

      {/* زر اختصار الوقت */}
      <button
        onClick={handleOrderClick}
        style={{
          padding: '14px',
          width: '100%',
          maxWidth: '320px',
          margin: '12px auto',
          border: 'none',
          borderRadius: '12px',
          backgroundColor: '#e67e22',
          color: '#fff',
          fontSize: '17px',
          fontWeight: '700',
          boxShadow: '0 4px 12px rgba(230,126,34,0.4)',
        }}
      >
        اطلب الآن 🍔
      </button>
    </div>
  );
}
